import { PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import { deleteMockProject } from './mockProjects';
import { mockDelay, readMockProjectError } from './mockUtils';

export interface DeleteProjectRequest {
  projectId: string;
}

const MOCK_RESPONSE_DELAY_MS = 600;

const deleteProjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteProject: builder.mutation<void, DeleteProjectRequest>({
      // The backend `DELETE /projects/{projectId}` endpoint does not exist yet: edit the mock list (see mockProjects.ts).
      queryFn: async ({ projectId }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        return deleteMockProject(projectId)
          ? { data: undefined }
          : { error: { status: 404, data: 'Project not found' } };
      },
      // The project's own query is left alone: refetching it now would only 404 on the page being left.
      invalidatesTags: (_result, error) => (error ? [] : [{ type: PROJECTS_LIST_TAG }]),
    }),
  }),
});

export const { useDeleteProjectMutation } = deleteProjectApi;
